import {
  dashboardErrorMocks,
  DashboardResponse
} from '@com-delta-idp/mnx-oauth';
import { DefaultLookUpSuccessResponse } from '../model/common-service.interface';

export const CommonServiceMocks = {
  removeDeepLinkVendorCookie: {}
};

export const DefaultLookUpSuccessResponseMock: DefaultLookUpSuccessResponse = {
  lookupId: 'DEFAULT',
  tripType: {
    default: '{"key":"rt"}',
    Name: 'tripType',
    Values: [
      {
        key: 'rt',
        value: 'ROUND_TRIP'
      },
      {
        key: 'ow',
        value: 'ONE_WAY'
      },
      {
        key: 'mc',
        value: 'MULTI_CITY'
      }
    ]
  },
  passengers: {
    default: '{"key":"3Passenger"}',
    Name: 'passengers',
    Values: [
      {
        key: '1 Passenger'
      },
      {
        key: '2 Passenger'
      },
      {
        key: '3 Passenger'
      }
    ]
  },
  request: {
    default: '',
    Name: 'request',
    Values: [
      {
        pageName: 'ADV_SEARCH'
      }
    ]
  },
  defaultMap: {
    flexCheck: false,
    flexairportsearch: false,
    refundableFlightsOnly: false,
    calendarsearch: false,
    deltaAndPartners: true,
    nonstopFlightsOnly: false
  },
  disableBestFares: false,
  disableEdocLink: false,
  disableFlexibleDates: false,
  disableMeetingCode: false,
  disableNearbyAirport: false,
  disablePaxDropDown: false,
  disableRefundableFares: false,
  disableShowPriceIn: false,
  disableTripType: false,
  edocDefaultPaxCount: 0,
  edocMaxPaxCount: 0,
  edocMinPaxCount: 0,
  edocSearch: 0,
  fareBrandsByMiles: {
    default: '',
    Name: 'fareBrandsByMiles',
    Values: [
      {
        brandID: 'BE',
        brandName: 'Basic Economy'
      },
      {
        brandID: 'MAIN',
        brandName: 'Main Cabin'
      },
      {
        brandID: 'DCP',
        brandName: 'Delta Comfort+'
      },
      {
        brandID: 'FIRST',
        brandName: 'First Class'
      },
      {
        brandID: 'DPPS',
        brandName: 'Premium Select'
      },
      {
        brandID: 'D1',
        brandName: 'Delta One'
      }
    ]
  },
  fareBrandsByMoney: {
    default: '',
    Name: 'fareBrandsByMoney',
    Values: [
      {
        brandID: 'BE',
        brandName: 'Basic Economy'
      },
      {
        brandID: 'MAIN',
        brandName: 'Main Cabin'
      },
      {
        brandID: 'DCP',
        brandName: 'Delta Comfort+'
      },
      {
        brandID: 'FIRST',
        brandName: 'First Class'
      },
      {
        brandID: 'DPPS',
        brandName: 'Premium Select'
      },
      {
        brandID: 'D1',
        brandName: 'Delta One'
      }
    ]
  },
  flexOptions: {
    default: 'FLEX_DAYS',
    Name: 'flexOptions',
    Values: [
      {
        value: 'FLEX_DAYS',
        isDefaulted: 'true'
      },
      {
        value: 'WEEKS',
        isDefaulted: 'false'
      }
    ]
  },
  journeyTypeOptions: {
    default: '',
    Name: 'journeyTypeOptions',
    Values: [
      {
        value: 'ROUND_TRIP',
        isDefaulted: 'true'
      },
      {
        value: 'ONE_WAY',
        isDefaulted: 'false'
      },
      {
        value: 'MULTICITY',
        isDefaulted: 'false'
      }
    ]
  },
  meetingEventSearch: false,
  paxDefaults: {
    default: '',
    Name: 'paxDefaults',
    Values: [
      {
        paxCode: 'ADT',
        paxDesc: 'Adult',
        defaultCount: '1',
        maximumPaxCount: '9'
      }
    ]
  },
  RadiusDefaults: {
    default: '',
    Name: 'RadiusDefaults',
    Values: [
      {
        unit: 'MI',
        measure: '0',
        value: 'Miles',
        isDefaulted: 'false'
      },
      {
        unit: 'MI',
        measure: '25',
        value: 'Miles',
        isDefaulted: 'false'
      },
      {
        unit: 'MI',
        measure: '50',
        value: 'Miles',
        isDefaulted: 'false'
      },
      {
        unit: 'MI',
        measure: '100',
        value: 'Miles',
        isDefaulted: 'true'
      }
    ]
  },
  shopTypeOptions: {
    default: '',
    Name: 'shopTypeOptions',
    Values: [
      {
        value: 'MONEY',
        isDefaulted: 'true'
      },
      {
        value: 'MILES',
        isDefaulted: 'false'
      }
    ]
  },
  useEdocDefaultPaxCount: false,
  sessionTimeoutLimit: 30,
  sessionTimeoutModelLimit: 15
};

export const DefaultLookUpErrorResponseMock = {
  code: 'string',
  message: 'string',
  developerMessage: 'string',
  moreInfo: [
    {
      code: 'string',
      field: 'string',
      message: 'string'
    }
  ]
};

export const dashboardMockResponse: DashboardResponse = {
  smNumber: '8006270311',
  firstName: 'Coco',
  lastName: 'Olive',
  smBalance: '820',
  membershipLevel: 'DM',
  enrollmentDate: '2014-05-27',
  prefix: 'Mr',
  primaryEmailAddress: 'test@example.com',
  preferredName: 'FR',
  cobrandCardtypeList: 'AXCV',
  isAbove18: true,
  medallionMemberDesc: 'Diamond Medallion',
  medallionMbrInd: '1',
  country: 'US',
  language: 'EN',
  customerID: '0008006270311',
  MQMBalance: '50000',
  loyaltyPromoInd: 'Y',
  loyaltyPromoLink: '/mypromos/displayPromotions',
  sysDrvdPrefHomeArptCd: 'MSP',
  usrProvdPrefHomeArptCd: 'JFK',
  crprtAgrmntId: '7814792|3000000008072|US123456789',
  crprtAgrmntTypeCode: 'CNA|CNA|SME',
  crprtPricingDiscCode: '579EQ00|4BW0F00| ',
  crprtName: '2CHECKOUT|GOOGLE|TAI',
  adminCompanyName: 'NA|NA|NA',
  smeCompanyName: 'tai',
  smeCardTypes: 'PLATINUM',
  skyPriority: true,
  pwmMbr: false,
  crprtAgrmntFound: true,
  skymilesMember: true,
  langPromptIndicator: false,
  rememberMeIndicator: false,
  millionMiler: false,
  irop: false,
  spgInd: false,
  firstTime: true,
  hasUserNm: false,
  is360Tier: false,
  promoCdInd: false,
  loggedIn: true,
  isWarmState: false,
  hasSQA: true,
  hasEmail: true,
  hasTripLink: 'N',
  hasNuTvl: 'N',
  hasPhone: true,
  permType: 'NA|NA|NA',
  pgmType: 'NA|NA|NA',
  accessToken: 'NA|NA|NA',
  userId: 'NA|NA|NA',
  program: 'NONE|CSA|SKYB',
  contractMgtEnt: 'NA|NAM|NA',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  formNameSubmitted: '',
  isEmailValid: true,
  middleName: '',
  milesExpireDate: '',
  millionMilerTier: '',
  nameSuffix: '',
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeLastName: '',
  spid: '',
  triplinkErrorCd: '',
  userNameType: '',
  venderID: '',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  errors: [dashboardErrorMocks],
  emailAddressLocalDate: '2024-04-18',
  cobrandCardtypeAffiliationIdList: '',
  cobrandCardtypeDescList: '',
  cobrandCardtypeSkyclubEligibleList: ''
};

export const nullResponse: DashboardResponse = {
  primaryEmailAddress: null,
  smNumber: null,
  membershipLevel: null,
  smeCardTypes: null,
  smBalance: null,
  MQMBalance: '',
  accessToken: '',
  adminCompanyName: '',
  canBookBasicEconomy: '',
  canBookNonRefundable: '',
  cartCnt: '',
  cartID: '',
  contractMgtEnt: '',
  country: '',
  crprtAgrmntFound: false,
  crprtAgrmntId: '',
  crprtAgrmntTypeCode: '',
  crprtName: '',
  crprtPricingDiscCode: '',
  customerID: '',
  cobrandCardtypeList: '',
  enrollmentDate: '',
  errors: [],
  firstName: '',
  firstTime: false,
  formNameSubmitted: '',
  hasEmail: false,
  hasNuTvl: '',
  hasSQA: false,
  hasTripLink: '',
  hasUserNm: false,
  hasPhone: false,
  irop: false,
  is360Tier: false,
  isAbove18: false,
  isEmailValid: false,
  isWarmState: false,
  langPromptIndicator: false,
  language: '',
  lastName: '',
  loggedIn: false,
  loyaltyPromoInd: '',
  loyaltyPromoLink: '',
  medallionMbrInd: '',
  medallionMemberDesc: '',
  middleName: '',
  milesExpireDate: '',
  millionMiler: false,
  millionMilerTier: '',
  nameSuffix: '',
  permType: '',
  pgmType: '',
  preferredName: '',
  prefix: '',
  program: '',
  promoCdInd: false,
  pwmMbr: false,
  rememberMeFirstName: '',
  rememberMeID: '',
  rememberMeIndicator: false,
  rememberMeLastName: '',
  skyPriority: false,
  skymilesMember: false,
  smeCompanyName: '',
  spgInd: false,
  spid: '',
  sysDrvdPrefHomeArptCd: '',
  triplinkErrorCd: '',
  userId: '',
  userNameType: '',
  usrProvdPrefHomeArptCd: '',
  venderID: '',
  isSkyClubMember: '',
  emailAddressLocalDate: '',
  cobrandCardtypeAffiliationIdList: '',
  cobrandCardtypeDescList: '',
  cobrandCardtypeSkyclubEligibleList: ''
};
